import { FormControlService } from './../../../../shared/services/form-control.service';
import { ApiService } from './../../../../shared/services/api.service';
import { Router } from '@angular/router';
import { AlertService } from './../../../../shared/services/alert.service';
import { FormGroup } from '@angular/forms';
import { FormEditor } from './../../../../models/editors/form-editor.base.model';
import { HostListener, Directive } from '@angular/core';
export const SUCCESS_MESSAGE = 'Uložení proběhlo úspěšně!';
export const ERROR_MESSAGE = 'Při ukládání bohužel nastala chyba. Zkuste to prosím později.';

@Directive()
export class FormDetailBase<T> {
    private _isModal = false;

    protected _id: string;
    public url: string;
    protected _redirect: string;
    protected _saveCallback: Function;
    protected _closeCallback: Function;
    protected _fieldsConfig: Array<FormEditor<any>> = [];

    protected _headerTitle: string;

    public entity: T;
    public form: FormGroup;

    public get fieldsConfig(): Array<FormEditor<any>> {
        return this._fieldsConfig;
    }

    public set fieldsConfig(fieldsConfig: Array<FormEditor<any>>) {
        this._fieldsConfig = fieldsConfig;
    }

    public formEditors: any;
    public isInitialized = false;
    public isSaving = false;

    public get headerTitle(): string {
        return this._headerTitle;
    }

    public get isModal(): boolean {
        return this._isModal;
    }

    public set isModal(isModal: boolean) {
        this._isModal = isModal;
    }

    constructor(
        protected _formService: FormControlService,
        protected _apiService: ApiService,
        protected _router: Router,
        protected _alertService: AlertService
    ) { }

    @HostListener('document:keyup', ['$event'])
    onKeyUp(ev: KeyboardEvent) {
        switch (ev.key) {
            case 'Escape':
                if (this.isModal) {
                    if (this._closeCallback && typeof this._closeCallback === 'function') {
                        this._closeCallback();
                    }
                }
                break;
            default:
                break;
        }
    }

    public save() {
        this.form.updateValueAndValidity();
        if (this.form.valid) {
            this.isSaving = true;
            if (this._id) {
                this._apiService.put(this.form.value, this.url + '/' + this._id).subscribe(
                    (response: any) => {
                        if ({ ...response }.status <= 0) {
                            this._alertService.error(ERROR_MESSAGE);
                        } else {
                            if (this._redirect) {
                                this._router.navigate([this._redirect]);
                            }
                            if (this._saveCallback && typeof this._saveCallback === 'function') {
                                this._saveCallback(response);
                            }
                            this._alertService.success(SUCCESS_MESSAGE);
                        }
                        this.isSaving = false;
                    },
                    (error) => {
                        this._alertService.error(ERROR_MESSAGE);
                        this.isSaving = false;
                    }
                );
            } else {
                this._apiService.post(this.form.value, this.url).subscribe(
                    (response: any) => {
                        if ({ ...response }.status <= 0) {
                            this._alertService.error(ERROR_MESSAGE);
                        } else {
                            if (this._redirect) {
                                this._router.navigate([this._redirect]);
                            }
                            if (this._saveCallback && typeof this._saveCallback === 'function') {
                                this._saveCallback(response);
                            }
                            this._alertService.success(SUCCESS_MESSAGE);
                        }
                        this.isSaving = false;
                    },
                    (error) => {
                        this._alertService.error(ERROR_MESSAGE);
                        this.isSaving = false;
                    }
                );
            }
        }
    }

    protected _setupForm(): void {
        this.form = this._formService.toFormGroup(this.fieldsConfig.slice(), this.entity);
        this.formEditors = this._formService.toTemplateInput(this.fieldsConfig.slice(), this.entity);
        this.isInitialized = true;
    }

    protected _getEntity() {
        if (this._id) {
            this._apiService.get(this.url + '/' + this._id)
                .subscribe(
                    (response: any) => {
                        this.entity = { ...response }.data;
                        this._setupForm();
                    },
                    (error) => console.error(error)
                );
        } else {
            this._setupForm();
        }
    }
}
